// @material-ui/icons
import PeopleIcon from '@material-ui/icons/People'
import HeimratTenantsTab from '../components/tenant/heimrat/HeimratTenantsTab'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import CurrentHSV from '../components/engagement/CurrentHSV'
import HeimratEngagementApplication from '../components/engagement/HeimratEngagementApplication'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import HeimratEngagements from '../components/engagement/HeimratEngagements'

export const heimratDepartmentRoutes = [
  {
    path: '/dashboard/tenants',
    name: 'Bewohner',
    icon: PeopleIcon,
    component: HeimratTenantsTab,
  },
  {
    path: '/dashboard/engagements/all',
    name: 'Alle Ämter',
    icon: AssignmentIndIcon,
    component: HeimratEngagements,
  },
  {
    path: '/dashboard/applications',
    name: 'Bewerbungen',
    icon: AssignmentIndIcon,
    component: HeimratEngagementApplication,
  },
  {
    path: '/dashboard/departments/current',
    name: 'HSV',
    icon: DoneAllIcon,
    component: CurrentHSV,
  },
]
